import { initializeApp } from '@firebase/app';
import { getMessaging, getToken, onMessage } from '@firebase/messaging';
import UserService from '../api/users';
import { message as antdMessage } from 'antd'; 
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCnVcZguwCRZJ7i9GPVbrziXsVdlyBMJ3c",
  authDomain: "app-epno-qa.firebaseapp.com",
  databaseURL: "https://app-epno-qa-default-rtdb.firebaseio.com/",
  projectId: "app-epno-qa",
  storageBucket: "app-epno-qa.firebasestorage.app",
  messagingSenderId: "665181193587",
  appId: "1:665181193587:web:fb0a61f786b66f8a847106",
  measurementId: "G-MKHKW225M5"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
const analytics = getAnalytics(firebaseApp);


const setupNotifications = async (foregroundNotificationCallback) => {
  try {
    // Request notification permission
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      // Retrieve the FCM token
      const token = await getToken(messaging);
      localStorage.setItem("fcm", token);

      const user = JSON.parse(localStorage.getItem('user'));
      UserService.SaveToken({ token, userId: user.id })
        .then(response => {
        })
        .catch(error => console.error('Error saving the token:', error));
    } else {
    }

    // Handle foreground messages
    onMessage(messaging, (payload) => {

      // Use the callback passed to the function to handle the foreground notification
      if (foregroundNotificationCallback) {
        foregroundNotificationCallback(payload);
      }

      // Optionally, show a toast message using AntD
      antdMessage.info({
        content: `${payload.data.title}: ${payload.data.body}`, // Customize based on your notification structure
        duration: 2, // Duration in seconds for the message
        style: { marginTop: '10vh' }, // Optional: Custom style for the message
      });
    });
  } catch (error) {
    console.error('Error setting up notifications:', error);
  }
};

export { messaging, setupNotifications };
